<div>
  <div class="footer">
    <div class="divider"></div>
    <div class="footer-links">
      <ul>
        <!-- <router-link to="/about" tag="li"><a>About</a></router-link>-->
        <!-- <router-link to="/privacy" tag="li"><a>Privacy</a></router-link>
        <router-link to="/terms" tag="li"><a>Terms</a></router-link>
        <router-link to="/" tag="li"><a>© Smardie</a></router-link> -->
      </ul>
    </div>
  </div>

  <div class="clearfix"></div>
</div>